import { computed, onMounted, ref, watch } from 'vue';

import useAjax from '@/functions/use_ajax';

export default function useRemoteObject(pathRef) {
  const ajax = useAjax();

  const object = ref(null);

  const loadAndSet = async () => {
    let { ok, data } = await ajax(pathRef.value);
    object.value = ok ? data : null;
  };

  onMounted(loadAndSet);
  watch(pathRef, loadAndSet);

  return object;
}

export function useOrganisation(props) {
  const path = computed(() => `/organisations/${props.organisationId}`);
  return useRemoteObject(path);
}

export function useOperation(props) {
  const path = computed(() => `/organisations/${props.organisationId}/operations/${props.operationId}`);
  return useRemoteObject(path);
}

export function useOperationHme(props) {
  const path = computed(
    () =>
      `/organisations/${props.organisationId}/operations/${props.operationId}/plants/heavy_mobile_equipments/${props.heavyMobileEquipmentId}`
  );
  return useRemoteObject(path);
}

export function useShaft(props) {
  const path = computed(() => `/organisations/${props.organisationId}/shafts/${props.shaftId}`);
  return useRemoteObject(path);
}

export function useShaftV2(props) {
  const path = computed(() => `/organisations/${props.organisationId}/shafts_v2/shafts/${props.shaftId}`);
  return useRemoteObject(path);
}

export function useShaftV2Station(props) {
  const path = computed(
    () =>
      `/organisations/${props.organisationId}/shafts_v2/shafts/${props.shaftId}/stations/${props.stationId}`
  );
  return useRemoteObject(path);
}

export function useShaftV2Hme(props) {
  const path = computed(
    () =>
      `/organisations/${props.organisationId}/shafts_v2/shafts/${props.shaftId}/heavy_mobile_equipments/${props.heavyMobileEquipmentId}`
  );
  return useRemoteObject(path);
}

export function useShip(props) {
  const path = computed(() => `/organisations/${props.organisationId}/ships/${props.shipId}`);
  return useRemoteObject(path);
}

export function useEquipment(props) {
  const path = computed(() => `/organisations/${props.organisationId}/equipment/${props.equipmentId}`);
  return useRemoteObject(path);
}
